import { CheckBox } from "../../components/reactHookFormFields/checkbox";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { IoIosArrowBack, IoIosArrowDown } from "react-icons/io";
import { toast } from "react-toastify";
import { AppListing } from "../../components/AppListing/Listing.view";
import MainPageDialog from "../../components/dialog";
import LetterOrderListing from "./LetterOrderListing";
import {
  shareDataApi,
  useGetPatientShareTriageNotesQuery,
  useGetRadiologyFileUidMutation,
  useGetShareDataBatchListQuery,
  usePrintLabOrderFileMutation,
  useUploadAttachmentMutation,
} from "../../services/shareDataService";
import { FaUserAlt } from "react-icons/fa";
import AttachTriageNotes from "../Triage-Module/AttachTriageNotes";
import LabResultListing from "./LabResultListing";
import { cloneDeep } from "lodash";
import RadiologogyResultListing from "./RadiologyResultLisiting";
import AttchBillingData, { billingDataCols } from "./billingData";
import ClinicalSummaryCCD from "./ClinicalSummaryCCD";
import moment from "moment";
import AttachScreeningList from "./attachScreeningList";
import { IoIosClose } from "react-icons/io";
import { FcImageFile } from "react-icons/fc";
import { DatePickerFeild } from "../../components/reactHookFormFields/datePicker";
import { RadioInputField } from "../../components/reactHookFormFields/radio";
import AllAppointments, {
  appointmentCols,
} from "../appointment/AllAppointments";
import { PrintProcedures } from "../../components/PrintProcedure/PrintProcedures";
import SignedEncounterDialogue from "../SignedEncounters/SignedEncounterDialogue";
import { Documents } from "../documents/Documents";
import { ReferralsDialog } from "../referrals";
import { getReferralPrintId } from "../referrals/Referrals.service";
import { lettersOrdersApi } from "../../services/lettersOrdersService";
import { getBaseUrl, parseResponse } from "../../helper";
import { TinyEditor } from "./LetterOrderListing/tinyEditor";
import { TabbedPanelE10x } from "../../components/tabbedPanel/tabbed_panel";
import ProccessingDataComponent from ".";
import ProcessedDataComponent from "./ProcessedDataComponent";
import ShareDownload from "./ShareDownload";
import FullScreenLoader from "../../components/FullScreenLoader";
import { PatientSearchField } from "../../components/reactHookFormFields/patientSearchField";
import { ReactSelectField } from "../../components/reactHookFormFields/selectField";
import { useGetDocumentsCategoriesQuery } from "../../services/documentService";
import { useGroupChatContext } from "../../context/groupchatContext";

function ShareData({
  shareDataArr,
  setShareDataArr,
  control,
  setValue,
  watch,
  selectedChat,
  attachDocumentHandler,
  isLocationTab,
  resetHandler,
}) {
  const [selectedTab, setSelectedTab] = useState("patient_data");
  const [proccesDataList, setProccesDataList] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [previewDialog, setPreviewDialog] = useState({ open: false });
  const [dialogState, setDialogState] = useState({
    open: false,
    slug: "",
    activeKey: "",
  });
  const [processedDataList, setProcessedDataList] = useState([]);
  const [getPreviewTemplates] =
    lettersOrdersApi.endpoints.getPreviewTemplates.useLazyQuery();
  const [printLabOrderFile] = usePrintLabOrderFileMutation();
  const [fileUid] = useGetRadiologyFileUidMutation();
  const [getAttachment, { isLoading: isLoadingAttachment }] =
    shareDataApi?.endpoints?.getAttachment?.useLazyQuery();
  const [getNotesPreview] =
    shareDataApi?.endpoints?.getNotesPreview?.useLazyQuery();
  const [openForm, setOpenForm] = useState(false);
  const [openTemplateModal, setOpenTemplateModal] = useState(false);
  const [selectedLetter, setSelectedLetter] = useState(null);
  const [processingItem, setProcessingItem] = useState(null);
  const [editorActions, setEditorActions] = useState("view");
  const [showFaxPopup, setShowFaxPopup] = useState({ open: false });
  const [shareDataList, setShareDataList] = useState([]);
  const [showPrintShareView, setShowPrintView] = useState(false);
  const [loading, setLoading] = useState(false);
  const fileInputRef = useRef(null);
  const {
    practice: { id: practice_id },
    auth: authToken,
  } = JSON.parse(localStorage.getItem("auth"));
  const { data: documentCategories } = useGetDocumentsCategoriesQuery(
    {
      practice_id: selectedChat?.location?.id,
      status: "all",
      title: "",
      flat: 1,
    },
    {
      skip: true,
    }
  );
  const { data: triageNotesData } = useGetPatientShareTriageNotesQuery(
    {
      pid: selectedChat?.pid,
      download: 1,
      page: 1,
    },
    {
      skip: !shareDataArr?.triageNotes?.selectedData?.length > 0,
    }
  );
  const { data: processData, isLoading: processingLoading } =
    useGetShareDataBatchListQuery({
      pid: selectedChat?.pid,
      status: "processing",
    });
  const { data: processedData, isLoading: processedLoading } =
    useGetShareDataBatchListQuery({
      pid: !isLocationTab ? selectedChat?.pid : "",
      status: "processed",
    });
  // const { data: sharedData  } = useGetShareDataBatchListQuery({
  //   pid: selectedChat?.pid,
  //   status: "shared",
  // });

  const [uploadAttachment, { isLoading: isUploading }] =
    useUploadAttachmentMutation();

  useEffect(() => {
    if (selectedChat) {
      resetHandler();
    }
  }, [selectedChat]);

  useEffect(() => {
    if (processedData?.response?.data?.length > 0) {
      setProcessedDataList(processedData?.response?.data);
    }
  }, [processedData?.response?.data]);
  useEffect(() => {
    if (processData?.response?.data?.length > 0) {
      setProccesDataList(processData?.response?.data);
    }
  }, [processData?.response?.data]);

  // useEffect(() => {
  //   if (sharedData?.response?.data?.length > 0) {
  //     setShareDataList(sharedData?.response?.data);
  //   }
  // }, [sharedData?.response?.data]);

  const closeDialog = () => {
    setDialogState({
      slug: "",
      open: false,
      activeKey: "",
    });
  };
  const openSheetHandler = () => {
    let params = "pid=" + selectedChat?.pid;
    params += "&token=" + authToken;
    params += "&tz=" + String(new Date().getTimezoneOffset());
    params += "&practice_id=" + practice_id;
    const url =
      process.env.REACT_APP_API_URL_V1 +
      "/reports/patient_sheet.json?" +
      params;
    window.open(url, "_blank");
  };
  // Handler to manage file uploads
  const handleFileUpload = (event) => {
    const files = event.target.files;
    if (files.length > 0) {
      const formData = new FormData();
      formData.append("file", files[0]);
      formData.append("type", files[0].type);
      uploadAttachment(formData).then((res) => {
        if (res?.data?.response?.code == 0) {
          let tempData = { ...shareDataArr };
          tempData?.uploads?.selectedData?.push(res?.data?.response?.data);
        } else {
          toast.error(res?.data?.response?.msg);
        }
      });
    }
  };

  // Effect to programmatically open file input when `uploads` case is rendered
  useEffect(() => {
    if (
      dialogState.open &&
      dialogState.slug === "uploads" &&
      fileInputRef.current
    ) {
      fileInputRef.current.click();
    }
  }, [dialogState]);
  // Preview in new tab
  const previewInNewTab = (item, currentObj) => {
    let params = "";
    let url = "";
    params += "&token=" + authToken;
    params += "&tz=" + String(new Date().getTimezoneOffset());
    params += "&practice_id=" + practice_id;
    params += "pid=" + selectedChat?.pid;
    if (currentObj?.slug === "documents") {
      params += "&id=" + item?.id;
      url = process.env.REACT_APP_API_URL_V1 + "/documents/view.json?" + params;
    } else if (currentObj?.slug === "uploads") {
      params += "&attachment=" + item?.attachment_id;
      url =
        process.env.REACT_APP_API_URL_V1 +
        "/utilities/get_attachment.json?" +
        params;
    } else if (currentObj?.slug === "triage") {
      params += "&attachment=" + triageNotesData?.uuid;
      params += "&actor_id=" + item?.updated_by;
      url =
        process.env.REACT_APP_API_URL_V1 +
        "/utilities/get_attachment.json?" +
        params;
    }

    window.open(url, "_blank");
  };
  const previewLetterOrder = async (item, currentObj) => {
    if (!processingItem) {
      const params = {
        id: item.id,
        pid: selectedChat?.pid,
      };
      if (true) {
        setEditorActions("view");
        params.portal = "provider";
      } else {
        setEditorActions("new");
        params.preview = "letter";
      }

      setProcessingItem(item.id);
      const res = await getPreviewTemplates(params);
      setProcessingItem(null);
      if (res?.data) {
        const { code, data } = parseResponse(res);
        setSelectedLetter(data || null);
        setShowFaxPopup({
          open: true,
          data: { ...data, uuid: data.file_id ? data.file_id : data.id },
        });
      } else {
        setProcessingItem(null);
        setSelectedLetter({
          is_signed: 0,
          template: "",
        });
      }
      setOpenTemplateModal(true);
    }
  };
  const previewReferral = (item, currentObj) => {
    getReferralPrintId({ id: item?.id }).then((res) => {
      // let id = res?.data?.response?.data;
      setDialogState({
        open: true,
        slug: "Referrals",
        printLink: "efax/read_document?file_name",
        data: { ...res?.data?.data, uuid: res?.data?.response?.data },
      });
    });
  };

  // open pdf dialog preview
  const dialogPreview = async (item, current) => {
    let res;
    let slug;
    setLoading(true);
    if (current?.slug === "labResults") {
      slug = "Lab Result";
      res = await printLabOrderFile({ id: item?.LabResult?.lab_order_id });
    } else if (current?.slug === "radiologyResults") {
      slug = "Radiology";
      res = await fileUid({ radiology_id: item.id });
    } else if (current?.slug === "referrals") {
      slug = "Referral";
      let data = await getReferralPrintId({ id: item.id });
      res = { data: { data: { file_uuid: data?.data?.response?.data } } };
    }
    setLoading(false);
    setDialogState({
      open: true,
      slug: slug,
      printLink: "efax/read_document?file_name",
      data: { ...res?.data?.data, uuid: res?.data?.data?.file_uuid },
    });
  };

  const previewData = (item, current) => {
    let newState = {
      open: true,
      slug: current.slug,
      source: `${current.slug}_preview`,
    };
    if (current?.slug === "ccd") {
      setLoading(true);
      setPreviewDialog({
        ...newState,
        // uuid: item?.response?.meta?.file_uuid,
        url: `${getBaseUrl()}/utilities/get_attachment.json?attachment=${
          item?.response?.meta?.file_uuid
        }&token=${authToken}&tz=${new Date().getTimezoneOffset()}`,
      });
    } else if (current?.slug === "encounter") {
      getNotesPreview({ include_addendum_in_preview: 1 }).then((res) => {
        newState.preview = res?.data?.response?.data?.preview;
        setPreviewDialog(newState);
      });
    } else if (current?.slug === "screening") {
      newState.data = item;
      setPreviewDialog(newState);
    }
  };

  const attachHandler = (data) => {
    if (data?.length > 0) {
      let tempData = { ...shareDataArr };
      tempData[dialogState.activeKey].selectedData = data;
      tempData[dialogState.activeKey].toggle = true;
      setShareDataArr({ ...tempData });
      setSelectedFiles([]);
      closeDialog();
    } else {
      toast.error("Please select at least one item to attach");
    }
  };
  const renderDialog = () => {
    if (dialogState.open) {
      switch (dialogState?.slug) {
        case "appointments":
          return (
            <AllAppointments
              selectedChat={selectedChat}
              setOpenAppointmentsListingDialogue={dialogState?.open}
              shareDataDetail={{
                slug: dialogState?.slug,
                closeDialog,
                attachHandler,
              }}
            />
          );
        case "referrals":
          return (
            <ReferralsDialog
              selectedChat={selectedChat}
              shareDataDetail={{
                slug: dialogState?.slug,
                closeDialog,
                attachHandler,
              }}
            />
          );
        case "documents":
          return (
            <>
              <MainPageDialog
                footerList={[
                  {
                    title: "Attach",
                    type: "save",
                    action: () => {
                      attachHandler(selectedFiles);
                    },
                  },
                  {
                    title: "Cancel",
                    type: "cancel",
                    action: () => closeDialog(),
                  },
                ]}
                title="All Document"
                footer={true}
                onCancelHandler={() => {
                  closeDialog();
                }}
              >
                <>
                  <Documents
                    selectedChat={selectedChat}
                    selectedFiles={selectedFiles}
                    setSelectedFiles={setSelectedFiles}
                    showUploadBtn={false}
                  />
                </>
              </MainPageDialog>
            </>
          );
        case "letterOrders":
          return (
            <>
              <LetterOrderListing
                selectedChat={selectedChat}
                shareDataDetail={{
                  slug: dialogState?.slug,
                  closeDialog,
                  attachHandler,
                  selectedFiles,
                  setSelectedFiles,
                }}
              />
            </>
          );
        case "triage":
          return (
            <AttachTriageNotes
              selectedChat={selectedChat}
              addTriageNotesDialog={true}
              shareDataDetail={{
                slug: dialogState?.slug,
                closeDialog,
                attachHandler,
                selectedFiles,
                setSelectedFiles,
              }}
            />
          );
        case "labResults":
          return (
            <LabResultListing
              selectedChat={selectedChat}
              shareDataDetail={{
                slug: dialogState?.slug,
                closeDialog,
                attachHandler,
                selectedFiles,
                setSelectedFiles,
              }}
            />
          );
        case "encounter":
          return (
            <SignedEncounterDialogue
              selectedChat={selectedChat}
              shareDataDetail={{
                slug: dialogState?.slug,
                closeDialog,
                attachHandler,
                setSelectedFiles,
                selectedFiles,
                path: "data_encounter",
              }}
            />
          );
        case "radiologyResults":
          return (
            <RadiologogyResultListing
              selectedChat={selectedChat}
              shareDataDetail={{
                slug: dialogState?.slug,
                closeDialog,
                attachHandler,
                setSelectedFiles,
                selectedFiles,
              }}
            />
          );
        case "uploads":
          return (
            <div>
              <input
                className="hidden"
                type="file"
                ref={fileInputRef}
                onChange={handleFileUpload}
              />
            </div>
          );
        case "billingData":
          return (
            <AttchBillingData
              selectedChat={selectedChat}
              shareDataDetail={{
                slug: dialogState?.slug,
                closeDialog,
                attachHandler,
                setSelectedFiles,
                selectedFiles,
              }}
            />
          );
        case "ccd":
          return (
            <ClinicalSummaryCCD
              selectedChat={selectedChat}
              shareDataDetail={{
                slug: dialogState?.slug,
                closeDialog,
                attachHandler,
                shareDataArr,
                setShareDataArr,
                setSelectedFiles,
                selectedFiles,
              }}
            />
          );
        case "screening":
          return (
            <AttachScreeningList
              selectedChat={selectedChat}
              shareDataDetail={{
                slug: dialogState?.slug,
                closeDialog,
                attachHandler,
                shareDataArr,
                setShareDataArr,
                setSelectedFiles,
                selectedFiles,
              }}
            />
          );

        case "Referrals":
          return (
            <PrintProcedures
              selectedChat={selectedChat}
              title={dialogState?.slug}
              printLink={dialogState?.printLink}
              printData={dialogState?.data}
              userUniqueId={dialogState?.data}
              setShowPrintShareView={() =>
                setDialogState({
                  open: false,
                  slug: "",
                })
              }
            />
          );
        case "Lab Result":
        case "Radiology":
        case "Referral":
          return (
            <PrintProcedures
              title={dialogState?.slug}
              printLink={dialogState?.printLink}
              printData={dialogState?.data}
              userUniqueId={dialogState?.data}
              setShowPrintShareView={() =>
                setDialogState({
                  open: false,
                  slug: "",
                })
              }
            />
          );
      }
    }
  };
  const removeHandler = (index, objKey) => {
    let modifyShareDataArr = cloneDeep(shareDataArr);
    modifyShareDataArr[objKey]?.selectedData?.splice(index, 1);
    setShareDataArr(modifyShareDataArr);
  };
  const CommonList = ({ labelKey, objKey, onClick }) => {
    function getValue(path, shareDataObj) {
      let obj = { ...shareDataObj };
      return path.split("?.").reduce((acc, key) => {
        return acc?.[key];
      }, obj);
    }
    // const previewReferral = (item) => {
    //   getReferralPrintId({ id: item.id }).then((res) => {
    //     if (res?.data?.response.code == 0) {
    //       setShowPrintView(true);
    //       setUploadFileId({
    //         ...d,
    //         uuid: res?.data?.response.data,
    //       });
    //     }
    //   });
    // };
    return (
      <>
        {shareDataArr[objKey]?.selectedData?.map((shareDataObj, index) => (
          <div
            className="m-1 border px-2 py-1 bg-sky-100 text-blue-500 flex items-center cursor-pointer"
            onClick={() => {
              onClick(shareDataObj, shareDataArr[objKey]);
            }}
          >
            {shareDataArr[objKey]?.slug === "uploads" && (
              <FcImageFile className="size-4" />
            )}
            <div>{getValue(labelKey, shareDataObj)}</div>
            <span
              className="text-red-700 ml-4 cursor-pointer"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                removeHandler(index, objKey);
              }}
            >
              x
            </span>
          </div>
        ))}
      </>
    );
  };
  const renderSelectedData = (key) => {
    switch (shareDataArr[key]?.slug) {
      case "appointments":
        let setappointmentCols = appointmentCols?.filter(
          (v, k) => v?.key != "updated_by_name"
        );
        setappointmentCols?.push({
          title: "",
          key: "",
          colWidth: "1",
          getData: (item, index) => {
            return (
              <span>
                <IoIosClose
                  size={25}
                  className="text-red-600"
                  onClick={() => {
                    removeHandler(index, key);
                  }}
                />
              </span>
            );
          },
        });
        return (
          <AppListing
            listData={shareDataArr[key]?.selectedData}
            cols={setappointmentCols}
          />
        );
      case "billingData":
        let setBillingCols = billingDataCols?.filter(
          (v, k) => v?.key != "location_name"
        );
        setBillingCols?.push({
          title: "",
          key: "",
          colWidth: "1",
          getData: (item, index) => {
            return (
              <span>
                <IoIosClose
                  size={25}
                  className="text-red-600"
                  onClick={() => {
                    removeHandler(index, key);
                  }}
                />
              </span>
            );
          },
        });
        return (
          <AppListing
            listData={shareDataArr[key]?.selectedData}
            cols={setBillingCols}
          />
        );
      case "referrals":
        return (
          <div className="flex flex-wrap ">
            <CommonList
              objKey={key}
              labelKey={"referred_to_date"}
              onClick={dialogPreview}
            />
          </div>
        );
      case "documents":
        return (
          <div className="flex flex-wrap">
            <CommonList
              objKey={key}
              labelKey={"title"}
              onClick={previewInNewTab}
            />
          </div>
        );
      case "letterOrders":
        return (
          <div className="flex flex-wrap">
            <CommonList
              objKey={key}
              labelKey={"created"}
              onClick={previewLetterOrder}
            />
          </div>
        );
      case "triage":
        return (
          <div className="flex flex-wrap">
            <CommonList
              objKey={key}
              labelKey={"created"}
              onClick={previewInNewTab}
            />
          </div>
        );
      case "encounter":
        return (
          <div className="flex flex-wrap">
            <CommonList objKey={key} labelKey={"date"} onClick={previewData} />
          </div>
        );
      case "uploads":
        return (
          <div className="flex flex-wrap">
            <CommonList
              onClick={previewInNewTab}
              objKey={key}
              labelKey={"title"}
            />
          </div>
        );
      case "labResults":
        return (
          <div className="flex flex-wrap">
            <CommonList
              objKey={key}
              labelKey={"created"}
              onClick={dialogPreview}
            />
          </div>
        );
      case "radiologyResults":
        return (
          <div className="flex flex-wrap">
            <CommonList
              objKey={key}
              labelKey={"created"}
              onClick={dialogPreview}
            />
          </div>
        );
      case "ccd":
        return (
          <div className="flex flex-wrap">
            <CommonList
              objKey={key}
              labelKey={"response?.meta?.txt_file"}
              onClick={previewData}
            />
          </div>
        );
      case "screening":
        return (
          <div className="flex flex-wrap">
            <CommonList
              objKey={key}
              labelKey={"modified"}
              onClick={previewData}
            />
          </div>
        );
    }
  };
  const ShareDataTabs = [
    {
      title: "Patient Data",
      type: "patient_data",
      active: true,
    },
    {
      title: `Processing Queue (${proccesDataList?.length})`,
      type: "processing_queue",
      active: true,
    },
    {
      title: `Processed (${processedDataList?.length})`,
      type: "processed",
      active: false,
    },
    // {
    //   title: `Shared/Downloaded (${shareDataList?.length})`,
    //   type: "shared_downloaded",
    //   active: false,
    // },
  ];
  const selectGroup = (tab) => {
    setSelectedTab(tab.type);
  };
  return (
    <>
      {loading && <FullScreenLoader />}
      {showPrintShareView && (
        <PrintProcedures
          title="Referral"
          getFileUrl={getFileUrl}
          printLink={"utilities/get_attachment.json?attachment"}
          printData={uploadFileId}
          userUniqueId={uploadFileId}
          setShowPrintShareView={setShowPrintView}
        />
      )}
      {openTemplateModal ? (
        <MainPageDialog
          modalSize="md"
          title={
            editorActions == "view"
              ? "Letter/Order Template"
              : "Generate Letter"
          }
          footer={false}
          onCancelHandler={() => {
            setOpenTemplateModal(false);
            setSelectedLetter(null);
          }}
          component={
            <TinyEditor
              // printAction={printAction}
              readOnly={selectedLetter?.is_signed == 1 ? true : false}
              setSelectedLetter={() => {
                setOpenTemplateModal(false);
                setOpenForm(false);
                setSelectedLetter(null);
              }}
              // signTemplate={signTemplate}
              // signingLetter={signingLetter}
              defaultTemplate={selectedLetter?.template}
              template_name={selectedLetter?.template_name}
              {...selectedLetter}
            />
          }
        />
      ) : (
        ""
      )}
      {openForm ? (
        <MainPageDialog
          title={"Letter/Order Templates"}
          footer={false}
          onCancelHandler={() => setOpenForm(false)}
          component={
            <LetterOrderForm
              getLetterPreview={getLetterPreview}
              processingItem={processingItem}
              onCancelHandler={() => {
                setSelectedLetter(null);
                setOpenForm(false);
              }}
              closeHandler={() => {
                setSelectedLetter(null);
                setOpenForm(false);
              }}
            />
          }
        />
      ) : (
        ""
      )}
      {/* preview dialog */}
      {(previewDialog?.slug === "ccd" ||
        previewDialog?.slug === "encounter" ||
        previewDialog?.slug === "screening") &&
        previewDialog.open && (
          <MainPageDialog
            title={
              (previewDialog?.slug === "ccd" && "View CCD") ||
              (previewDialog?.slug === "encounter" && "Encounter Preview") ||
              (previewDialog?.slug === "screening" &&
                previewDialog?.data?.created)
            }
            maxHeight={previewDialog?.slug == "screening" && true}
            modalSize={previewDialog?.slug == "screening" ? "md" : "md"}
            footerList={[
              {
                title: "Cancel",
                type: "cancel",
                action: () => setPreviewDialog({ open: false }),
              },
            ]}
            onCancelHandler={() => setPreviewDialog({ open: false })}
          >
            {
              previewDialog?.slug === "ccd" && (
                <iframe
                  id="viewPdfFrame"
                  width="100%"
                  height="100%"
                  frameborder="1"
                  allow="autoplay"
                  src={previewDialog?.url}
                  onLoad={() => setLoading(false)}
                ></iframe>
              )
              // <p dangerouslySetInnerHTML={{ __html: previewDialog?.data }}></p>)
            }
            {previewDialog?.slug === "encounter" && (
              <>
                <p
                  dangerouslySetInnerHTML={{ __html: previewDialog?.preview }}
                ></p>
              </>
            )}
            {previewDialog?.slug === "screening" && (
              <p
                className="text-left"
                dangerouslySetInnerHTML={{
                  __html: previewDialog?.data?.form_text,
                }}
              ></p>
            )}
          </MainPageDialog>
        )}
      {dialogState?.open && renderDialog()}
      <div className="flex flex-row  border-b -pb-1 sticky top-0 bg-white">
        <TabbedPanelE10x tabs={ShareDataTabs} onTabChange={selectGroup} />
      </div>
      <div className="mt-5">
        {selectedTab == "patient_data" ? (
          <>
            {Object?.keys(shareDataArr)?.map((v, k) => (
              <div
                className="border shadow select-none	"
                onClick={() => {
                  if (!shareDataArr[v]?.showCheckBox) {
                    let tempData = { ...shareDataArr };
                    tempData[v].toggle = !tempData[v]?.toggle;
                    setShareDataArr({ ...tempData });
                  }
                }}
              >
                <div className="flex justify-between bg-teal1000 items-center text-white p-2 font-bold cursor-pointer hover:bg-[#58979d] ">
                  <div
                    className={`text-sm shadow-inherit font-medium text-white   px-2 py-1.5 tracking-wider ${
                      shareDataArr[v]?.showCheckBox && " flex "
                    }`}
                  >
                    <span>
                      {shareDataArr[v]?.showCheckBox && (
                        <CheckBox
                          control={control}
                          name={shareDataArr[v]?.slug}
                          onChange={(e) => {
                            let tempData = { ...shareDataArr };
                            tempData[v].isChecked = e.target.checked
                              ? true
                              : false;
                            setShareDataArr({ ...tempData });
                          }}
                        />
                      )}
                    </span>
                    {shareDataArr[v]?.title}
                    {shareDataArr[v]?.selectedData?.length > 0 && (
                      <span className="ml-1 text-yellow-200">
                        ({shareDataArr[v]?.selectedData?.length})
                      </span>
                    )}
                  </div>
                  <div className="flex items-center gap-2">
                    {shareDataArr[v]?.slug === "uploads" && isUploading && (
                      <svg
                        class="h-8 w-8 animate-spin stroke-white"
                        viewBox="0 0 256 256"
                      >
                        <line
                          x1="128"
                          y1="32"
                          x2="128"
                          y2="64"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="24"
                        ></line>
                        <line
                          x1="195.9"
                          y1="60.1"
                          x2="173.3"
                          y2="82.7"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="24"
                        ></line>
                        <line
                          x1="224"
                          y1="128"
                          x2="192"
                          y2="128"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="24"
                        ></line>
                        <line
                          x1="195.9"
                          y1="195.9"
                          x2="173.3"
                          y2="173.3"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="24"
                        ></line>
                        <line
                          x1="128"
                          y1="224"
                          x2="128"
                          y2="192"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="24"
                        ></line>
                        <line
                          x1="60.1"
                          y1="195.9"
                          x2="82.7"
                          y2="173.3"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="24"
                        ></line>
                        <line
                          x1="32"
                          y1="128"
                          x2="64"
                          y2="128"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="24"
                        ></line>
                        <line
                          x1="60.1"
                          y1="60.1"
                          x2="82.7"
                          y2="82.7"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="24"
                        ></line>
                      </svg>
                    )}
                    <div className="flex items-center gap-2">
                      {shareDataArr[v]?.slug == "appointments" && (
                        <div
                          onClick={(e) => {
                            e.stopPropagation();
                          }}
                        >
                          <CheckBox
                            control={control}
                            name="appointment_csv"
                            title="CSV"
                          />
                        </div>
                      )}
                      {shareDataArr[v]?.slug == "documents" && (
                        <div
                          className="w-[250px]"
                          onClick={(e) => {
                            e.stopPropagation();
                          }}
                        >
                          {isLocationTab && (
                            <ReactSelectField
                              control={control}
                              name="document_type"
                              optionData={documentCategories}
                              showLabel="name"
                              placeholder="All Document Types"
                            />
                          )}
                        </div>
                      )}
                      {shareDataArr[v]?.showAttachDialogState && (
                        <>
                          <button
                            className="block text-sm shadow-inherit font-medium text-white bg-teal1000 hover:bg-[#58979d] hover:shadow-xl hover:duration-300 hover:ease-in-out hover:transform px-2 py-1.5 rounded tracking-wider border-2 w-fit"
                            onClick={(e) => {
                              if (shareDataArr[v]?.selectedData?.length > 0) {
                                setSelectedFiles(shareDataArr[v]?.selectedData);
                              }
                              e.preventDefault();
                              e.stopPropagation();
                              setDialogState({
                                open: true,
                                slug: shareDataArr[v]?.slug,
                                activeKey: v,
                              });
                            }}
                          >
                            Attach {shareDataArr[v]?.title}
                          </button>
                        </>
                      )}
                      {shareDataArr[v]?.showAttachDialogState && (
                        <>
                          {shareDataArr[v]?.toggle ? (
                            <IoIosArrowDown size={20} />
                          ) : (
                            <IoIosArrowBack size={20} />
                          )}
                        </>
                      )}
                    </div>
                  </div>
                </div>
                {shareDataArr[v]?.toggle && (
                  <>
                    <div
                      className="p-2"
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                    >
                      {v == "filter" && (
                        <div className="grid grid-cols-12 mt-4 gap-4">
                          <div className="col-span-6">
                            <PatientSearchField
                              title="Patient Search"
                              name="patient"
                              control={control}
                              isMulti={true}
                              isDisabled={watch("all_patient") ? true : false}
                              location={selectedChat?.location?.id}
                            />
                          </div>
                          {/* <div className="col-span-2 mt-2">
                            <CheckBox
                              title="All Patient"
                              name="all_patient"
                              control={control}
                              dateTime={false}
                            />
                          </div> */}
                          <div className="col-span-3">
                            <DatePickerFeild
                              title="Start Date"
                              control={control}
                              name="start_date"
                              maxDate={new Date()}
                              dateTime={false}
                            />
                          </div>
                          <div className="col-span-3">
                            <DatePickerFeild
                              title="End Date"
                              control={control}
                              name="end_date"
                              minDate={watch("start_date")}
                              maxDate={watch("start_date") || new Date()}
                            />
                          </div>
                        </div>
                      )}
                      <div className="grid grid-cols-3 gap-2 ">
                        {shareDataArr[v]?.data?.map((dataObj, dataIndex) => (
                          <>
                            <div className="flex flex-col">
                              <div className="flex">
                                <CheckBox
                                  title={dataObj?.title}
                                  name={dataObj?.slug}
                                  control={control}
                                  onChange={(e) => {
                                    let tempData = { ...shareDataArr };
                                    tempData[v].data[dataIndex].checked =
                                      e.target.checked;
                                    if (
                                      !e.target.checked &&
                                      dataObj.showRadioButton
                                    ) {
                                      setValue(
                                        dataObj?.slug + "_" + "range",
                                        ""
                                      );
                                      setValue(
                                        dataObj?.slug + "_" + "end_date",
                                        ""
                                      );
                                      setValue(
                                        dataObj?.slug + "_" + "start_date",
                                        ""
                                      );
                                      tempData[v].data[dataIndex].range = "";
                                      tempData[v].data[dataIndex].start_date =
                                        "";
                                      tempData[v].data[dataIndex].end_date = "";
                                    }
                                    if (
                                      !e.target.checked &&
                                      dataObj?.slug == "patient_sheet"
                                    ) {
                                      setValue("csv", false);
                                    }
                                    setShareDataArr({ ...tempData });
                                  }}
                                />
                                {dataObj?.checked && (
                                  <>
                                    {dataObj?.showRadioButton && (
                                      <>
                                        <RadioInputField
                                          control={control}
                                          name={dataObj?.slug + "_" + "range"}
                                          onChange={(e) => {
                                            let tempData = { ...shareDataArr };
                                            tempData[v].data[dataIndex].range =
                                              e.target.value;
                                            setShareDataArr({ ...tempData });
                                          }}
                                          value={"all"} // to set default value at first render
                                          enableUpdate={true}
                                          data={[
                                            {
                                              label: "All",
                                              key: "all",
                                            },
                                            {
                                              label: "Range",
                                              key: "range",
                                            },
                                          ]}
                                        />
                                      </>
                                    )}
                                  </>
                                )}
                                {dataObj?.slug == "patient_sheet" && (
                                  <div className="flex  items-center">
                                    <div onClick={() => openSheetHandler()}>
                                      <FaUserAlt className="text-green-600 ml-1" />
                                    </div>
                                    <div className="ml-3">
                                      <CheckBox
                                        title={"CSV"}
                                        name={"csv"}
                                        disabled={
                                          watch("patient_sheet") ? false : true
                                        }
                                        control={control}
                                      />
                                    </div>
                                  </div>
                                )}
                              </div>
                              {dataObj?.showRadioButton &&
                                dataObj?.checked &&
                                dataObj?.range == "range" && (
                                  <div className="mt-3 gap-2 flex">
                                    <div className="w-1/3">
                                      <DatePickerFeild
                                        dateTime={false}
                                        control={control}
                                        title="Start date"
                                        name={
                                          dataObj?.slug + "_" + "start_date"
                                        }
                                        onChange={(e) => {
                                          let date =
                                            moment(e).format("YYYY-MM-DD");
                                          let tempData = { ...shareDataArr };
                                          tempData[v].data[
                                            dataIndex
                                          ].start_date = date;
                                          setShareDataArr({ ...tempData });
                                        }}
                                      />
                                    </div>
                                    <div className="w-1/3">
                                      <DatePickerFeild
                                        dateTime={false}
                                        control={control}
                                        title="End date"
                                        name={dataObj?.slug + "_" + "end_date"}
                                        onChange={(e) => {
                                          let date =
                                            moment(e).format("YYYY-MM-DD");
                                          let tempData = { ...shareDataArr };
                                          tempData[v].data[dataIndex].end_date =
                                            date;
                                          setShareDataArr({ ...tempData });
                                        }}
                                      />
                                    </div>
                                  </div>
                                )}
                            </div>
                          </>
                        ))}
                      </div>
                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                          e.preventDefault();
                        }}
                      >
                        {shareDataArr[v].hasOwnProperty("selectedData") && (
                          <>
                            {shareDataArr[v]?.selectedData?.length > 0 ? (
                              <>{renderSelectedData(v)}</>
                            ) : (
                              shareDataArr[v]?.title + " are not attached."
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  </>
                )}
              </div>
            ))}
          </>
        ) : selectedTab == "processed" ? (
          <>
            <ProcessedDataComponent
              processedLoading={processedLoading}
              attachDocumentHandler={attachDocumentHandler}
              processedDataList={processedDataList}
              setProcessedDataList={setProcessedDataList}
            />
          </>
        ) : selectedTab == "shared_downloaded" ? (
          <>
            <ShareDownload
              shareDataList={shareDataList}
              setShareDataList={setShareDataList}
            />
          </>
        ) : selectedTab == "processing_queue" ? (
          <ProccessingDataComponent
            processingLoading={processingLoading}
            proccesDataList={proccesDataList}
            setProccesDataList={setProccesDataList}
          />
        ) : (
          ""
        )}
      </div>
    </>
  );
}

export default ShareData;
